import React from "react";

export default function AboutUs() {
  return (
    <section id="about">
      <div className="about-section">

        {/* TITLE */}
        <div className="section-title">
          <span></span>
          <h2>ABOUT US</h2>
          <span></span>
        </div>

        <div className="about-container">

          <h3>Aeterna Homeo Health</h3>

          <p className="tagline">
            Where healing begins naturally.
          </p>

          <p>
            At our clinic, we believe in the gentle yet powerful science of
            homeopathy — a system of medicine that treats the root cause,
            not just the symptoms. Our goal is to restore balance in your
            body and mind through safe, natural, and personalized treatments.
          </p>

          <p>
            With years of experience and a deep understanding of classical
            homeopathy principles introduced by Samuel Hahnemann, we provide
            holistic care tailored to each individual.
          </p>

        </div>

      </div>
    </section>
  );
}